module.exports = __webpack_public_path__ + "img/yfh.82849d40.png";